import React from 'react';
import { Box, Typography } from '@mui/material';
import { DefaultLayout } from '../../components/layout/default-layout';
import { useMetaTitle } from '../../hooks';
import { useFeatureToggles } from '../../feature-toggles';
import { TenantAddonConstants, useTenantAddons } from '../../components/tenant-addons';
import { CircularProgressCentered } from '../../components/circular-progress-centered';
import { PageNotFound } from '../../404';
import { InterventionLadder } from './intervention-ladder/intervention-ladder';

export const managementInformationFeatureToggle = 'EnableLedelsesinformation';

const requiredTenantAddons = [TenantAddonConstants.Ledelsesinformation];

function ManagementInformationContent() {
  useMetaTitle('Ledelsesinformation');

  return (
    <Box sx={{ px: 2, pt: 3, pb: 6 }}>
      <Typography variant="h1" sx={{ fontSize: '1.35rem' }}>
        Ledelsesinformation
      </Typography>
      <InterventionLadder />
    </Box>
  );
}

export function ManagementInformationPage() {
  const { isFeatureEnabled } = useFeatureToggles();
  const { isTenantAddonEnabled, tenantAddons } = useTenantAddons();

  if (tenantAddons === undefined) {
    return <CircularProgressCentered />;
  }

  if (!isFeatureEnabled(managementInformationFeatureToggle) || !isTenantAddonEnabled(requiredTenantAddons)) {
    return <PageNotFound />;
  }

  return (
    <DefaultLayout>
      <ManagementInformationContent />
    </DefaultLayout>
  );
}
